<template>
  <div class="page center intro">
    <h1 class="tit">
      <b>
        <a @click="seleccionarIdioma('es')">hola</a>
         / 
        <a class="en" @click="seleccionarIdioma('en')">hello</a></b>
    </h1>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Intro',
  computed: {
    ...mapState(['idioma']),
  },
  methods: {
    seleccionarIdioma(idioma) {
      this.$store.dispatch('setIdioma', idioma);
      this.$store.dispatch('activateTransition');
      
      // Animate wave path - start immediately
      this.$nextTick(() => {
        const path = document.querySelector('.overlay__path');
        if (!path) return;
        
        const paths = {
          step1: {
            unfilled:  'M 0 100 v 0 c 50 0 50 0 100 0 V 100 H 0 Z',
            inBetween: 'M 0 100 v -33 c 54 30 65 -113 100 0 V 100 H 0 Z',
            filled:    'M 0 100 v -100 c 50 0 50 0 100 0 V 100 H 0 Z'
          }
        };
        const morphTo = (d, duration, easing) => new Promise((resolve) => {
          path.style.transitionProperty = 'd';
          path.style.transitionDuration = `${duration}ms`;
          path.style.transitionTimingFunction = easing;

          let done = false;
          const finish = () => {
            if (done) return;
            done = true;
            path.removeEventListener('transitionend', onEnd);
            resolve();
          };
          const onEnd = (e) => { if (e.propertyName === 'd') finish(); };
          path.addEventListener('transitionend', onEnd);

          requestAnimationFrame(() => {
            requestAnimationFrame(() => path.setAttribute('d', d));
          });

          setTimeout(finish, duration + 80); // red de seguridad
        });

        const riseEasing = 'cubic-bezier(0.6,0,1,0.4)';
        const settleEasing = 'cubic-bezier(0,0.6,0.4,1)';

        (async () => {
          path.style.transition = 'none';
          path.setAttribute('d', paths.step1.unfilled);
          void path.getBoundingClientRect(); // fuerza reflow

          await morphTo(paths.step1.inBetween, 700, riseEasing);
          await morphTo(paths.step1.filled, 500, settleEasing);
        })();
      });
      
      setTimeout(() => {
        this.$router.push('/home');
        this.$store.dispatch('deactivateTransition');
      }, 1500);
    }
  },
}
</script>
<style scoped lang="scss">
.intro {
  background-color: var(--color_accent);
  max-width: unset;
  .tit {
    color: var(--color_base_light);
    a {
      border-bottom: .1em solid var(--color_base_light);
      margin: 0 .5em;
      // &.en {
      //   position: relative;
      //   color: rgba(255,255,255,.1);
      //   border-bottom-color: rgba(255,255,255,.1);
      //   cursor: default;
      //   &:after {
      //   transition: width .5s ease-in;
      //     content: "not ready jet 😅";
      //     position: absolute;
      //     top: 100%;
      //     left: 0;
      //     // color: var(--color_accent);
      //     color: var(--color_base_light);
      //     font-size: clamp(1rem, 1.2vw, 1.5rem);
      //     font-family: var(--font_parr_ser);
      //     width: 0%;
      //     height: 2em;
      //     padding: 1em 1em 1em 0;
      //     opacity: 0;
      //     overflow-x: hidden;
      //     white-space: nowrap;
      //   }
      //   &:hover:after {
      //     width: 120%;
      //     opacity: 1;
      //   }
      // }
    }
  }
}
</style>
